import React from 'react'
import { Image as CloudinaryImage } from 'cloudinary-react'

export const Image = React.memo(({ src, ...props }) => (
  <CloudinaryImage {...props} secure publicId={(src || '').replace(/(.*\/)(gatsby-cloudinary.*)/, '$2')} />
))
